import { c as _c } from "react/compiler-runtime";
import { createRef, useEffect, useState, type FC, type PropsWithChildren } from 'react';
import classnames from 'classnames';
import Footer from '@sbt-web/footer';
import type { StickyBannerContent } from '@sbt-web/header';
import { NotificationsContainer } from '@sbt-web/ui';
import { NotificationsRef } from '@/shared/tools/Notifications';
import Header from './Header';
import '@sbt-web/footer/dist/index.css';
import ownClasses from './layout.module.scss';
interface Props {
  theme: string;
  pageName: string;
  categorySlug?: string | string[];
  stickyBannerContent?: StickyBannerContent;
}
const mainRef = createRef<HTMLElement>();
const Layout: FC<PropsWithChildren<Props>> = t0 => {
  const $ = _c(22);
  const {
    children,
    theme,
    pageName,
    categorySlug,
    stickyBannerContent
  } = t0;
  const [fixed, setFixed] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleScroll = () => {
        if (mainRef.current) {
          if (mainRef.current?.getBoundingClientRect().top <= 0) {
            setFixed(true);
          } else {
            setFixed(false);
          }
        }
      };
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[2] !== theme) {
    t3 = () => {
      document.body.classList.remove("theme-redCorporate", "theme-blueMotori", "theme-yellowMarket", "theme-purpleImmobili", "theme-greenLavoro");
      document.body.classList.add(`theme-${theme}`);
    };
    t4 = [theme];
    $[2] = theme;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  const t5 = `theme-${theme}`;
  let t6;
  if ($[5] !== t5) {
    t6 = classnames(ownClasses.wrapper, t5);
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = pageName === "listing" ? "listing" : "adview";
  let t8;
  if ($[7] !== categorySlug || $[8] !== stickyBannerContent || $[9] !== t7 || $[10] !== theme) {
    t8 = <div data-google-interstitial="false"><Header theme={theme} section={t7} categorySlug={categorySlug} stickyBannerContent={stickyBannerContent} /></div>;
    $[7] = categorySlug;
    $[8] = stickyBannerContent;
    $[9] = t7;
    $[10] = theme;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== fixed) {
    t9 = <div data-google-interstitial="false"><NotificationsContainer ref={NotificationsRef} removeAfter={3} max={5} fixed={fixed} size="medium" /></div>;
    $[12] = fixed;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== children || $[15] !== t9) {
    t10 = <main className={ownClasses.main} ref={mainRef}>{t9}{children}</main>;
    $[14] = children;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div data-google-interstitial="false"><Footer type="full" assetsBase={process.env.NEXT_PUBLIC_ASSETS_BASE_URL} /></div>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t6 || $[20] !== t8) {
    t12 = <div id="layout" className={t6} data-testid="layout">{t8}{t10}{t11}</div>;
    $[18] = t10;
    $[19] = t6;
    $[20] = t8;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
};
export default Layout;